module.exports = __webpack_public_path__ + "static/img/rank_23.29f0ecb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_23.png
// module id = 4vej
// module chunks = 0